import { useContext } from "react";
import { PortalAppContext } from "./PortalAppProvider";
import { usePortalAppService } from "@wexinc/wex-common-web";
import { Endpoints } from "services/api";

const useCopPortalAppService = () => {
  const { portalAppStore, dispatch } = useContext(PortalAppContext);
  const portalAppService = usePortalAppService(Endpoints.apiRoot);

  async function ensurePortalAppStoreIsInitialized() {
    if (!portalAppStore.isInitialized) {
      const portalApps = await portalAppService.getPortalApps();

      dispatch({
        type: "set-portal-apps",
        payload: portalApps,
      });
    }
  }

  function getPortalApps() {
    return portalAppStore.portalApps;
  }

  return {
    getPortalApps,
    ensurePortalAppStoreIsInitialized,
    portalAppStore,
  };
};

export default useCopPortalAppService;
